import { render, staticRenderFns } from "./cjcx.vue?vue&type=template&id=15729c80&scoped=true&"
import script from "./cjcx.vue?vue&type=script&lang=js&"
export * from "./cjcx.vue?vue&type=script&lang=js&"
import style0 from "./cjcx.vue?vue&type=style&index=0&id=15729c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15729c80",
  null
  
)

export default component.exports